import {z} from 'zod';
import {id} from '../global/globalModels';

export const resourceLiveStatus = z.object({
    resource: id,
    user: id,
});

export type ResourceLiveStatus = z.infer<typeof resourceLiveStatus>;
